import { SuspenseBoundary, useDeleteConfirmationDialog } from '@mews-commander/ui';
import { lt } from '@mews/framework';
import { useDeleteSettlementRule, useSettlementRuleMappedEntitiesSuspenseQuery } from '../queries';
import { WithPaymentPolicyId } from '../types';

interface Params {
    settlementRuleId: string;
    onSuccess?: () => void;
}

const DeleteConfirmationDialogContent = ({ paymentPolicyId }: WithPaymentPolicyId) => {
    const { data } = useSettlementRuleMappedEntitiesSuspenseQuery({ id: paymentPolicyId });
    return data && (data.rates.length > 0 || data.rateGroups.length > 0)
        ? lt('PaymentPolicyDeleteDialogContent')
        : lt('PaymentPolicyDeleteDialogZeroEntitiesContent');
};

export const useDeleteSettlementRuleDialog = ({ settlementRuleId, onSuccess }: Params) => {
    const deleteMutation = useDeleteSettlementRule();
    const deleteAction = async () =>
        deleteMutation.mutateAsync(
            { id: settlementRuleId },
            {
                onSuccess,
            }
        );

    return useDeleteConfirmationDialog({
        deleteAction,
        renderContent: () => (
            <SuspenseBoundary>
                <DeleteConfirmationDialogContent paymentPolicyId={settlementRuleId} />
            </SuspenseBoundary>
        ),
        title: lt('PaymentPolicyDeleteDialogTitle'),
    });
};
